import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import './index.css';
import App from './App';

const rootEl = document.getElementById('root');
if (!rootEl) {
  // The host page is shipped from this repo (index.html), so a missing
  // #root means the build asset wasn't deployed correctly. Throw early
  // instead of silently rendering nothing.
  throw new Error('Mount node #root not found in document.');
}

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
